import Playlist from "./components/playlist/playlist";
import Tracking from "./components/playlist/tracking";
import {TealiumClickModel} from "../tracking/tealium-model";

document.addEventListener("DOMContentLoaded", (event) => {

    if (document.getElementById('mediathek-playlist')) {
        let initialTrackingData = JSON.parse(document.getElementById('mediathek-playlist').dataset.tracking);
        let trackingCommonData = document.getElementById('mediathek-playlist').dataset.trackingcommon;
        let tracking = new Tracking(initialTrackingData);

        let id = initialTrackingData.bestellnummer || initialTrackingData.videoId

        let utagClick = new TealiumClickModel({
            //link_category: `Details-${id.replace('Z-', '')}-${initialTrackingData.videoName}`
            link_category: `${trackingCommonData}`
        });

        let playlistData = JSON.parse(document.getElementById('mediathek-playlist').dataset.playlist);
        let playlist = new Playlist();
        playlist.init({
            videos: playlistData,
            tracking: tracking,
            utagClick: utagClick
        });
        window.SK = window.SK || {};
        window.SK.playlist = playlist;

        console.log('🌞️ Playlist initialized');
    }

});